(function() {
  var descriptionSelectors = [
    '.product-block-list__item--description',
    '.product-meta__description'
  ];

  var collapsibleSelectors = [
    '.mc-product-collapsible',
    '.collapsible-content__wrapper'
  ];

  function findFirstMatchingElement(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var element = document.querySelector(selectors[i]);
      if (element) return element;
    }
    return null;
  }

  function hasDescriptionPassedViewport() {
    var descriptionElement = findFirstMatchingElement(descriptionSelectors);
    if (!descriptionElement) return false;

    var rect = descriptionElement.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom <= viewportHeight; // bottom passed viewport bottom
  }

  function isCollapsibleContentVisible() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < collapsibleSelectors.length; i++) {
      var elements = document.querySelectorAll(collapsibleSelectors[i]);
      if (!elements.length) continue;

      for (var j = 0; j < elements.length; j++) {
        var rect = elements[j].getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= viewportHeight) {
          continue;
        }
        return true; // element intersects the viewport
      }
    }
    return false;
  }

  function shouldShowBar() {
    return hasDescriptionPassedViewport() || isCollapsibleContentVisible();
  }

  function toggleVisibility() {
    var bar = document.querySelector('.mc-sticky-cta');
    if (!bar) return;

    if (shouldShowBar()) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }

  function onClick(event) {
    var target = event.target;
    if (!target) return;

    if (target.matches('[data-action="submit-product-form"]')) {
      var formId = target.getAttribute('data-form-id');
      if (!formId) return;
      var form = document.getElementById(formId);
      if (form) {
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }
    }

    if (target.matches('[data-action="back-to-top"]')) {
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    }
  }

  document.addEventListener('click', onClick);
  document.addEventListener('scroll', toggleVisibility, { passive: true });
  window.addEventListener('resize', toggleVisibility);
  document.addEventListener('DOMContentLoaded', toggleVisibility);
})();

